var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#CFD2F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1422_2394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5366 23.8594C13.4357 23.8594 12.5432 24.7518 12.5432 25.8528C12.5432 26.9537 13.4357 27.8461 14.5366 27.8461C15.637 27.8449 16.5287 26.9531 16.53 25.8528C16.53 24.7518 15.6375 23.8594 14.5366 23.8594Z",
    fill: "#0F1CB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2111 21.3025L30.9893 20.2883C30.9135 20.2547 30.8495 20.1994 30.8051 20.1294L28.8798 17.0604C28.5212 16.488 27.8912 16.1427 27.2157 16.1485H19.3918C18.781 16.1467 18.2041 16.4293 17.8313 16.9131L15.3553 20.1568C15.2999 20.2309 15.2215 20.2846 15.1323 20.3092L10.9942 21.4416C10.4033 21.6061 9.99589 22.1462 10 22.7596V24.2729C10 25.0263 10.5888 25.6528 11.3423 25.6528H11.7028C11.809 24.2528 12.9216 23.1402 14.3216 23.034C15.8867 22.9152 17.2517 24.0877 17.3705 25.6528H26.331C26.4372 24.2528 27.5498 23.1403 28.9498 23.034C30.5149 22.9152 31.88 24.0877 31.9987 25.6528H32.6577C33.4112 25.6528 34 25.0263 34 24.2729V22.5455C34.0042 22.012 33.6955 21.5257 33.2111 21.3025Z",
    fill: "#0F1CB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1648 23.8594C28.0638 23.8594 27.1714 24.7518 27.1714 25.8528C27.1714 26.9537 28.0638 27.8461 29.1647 27.8461C30.2651 27.8449 31.1569 26.9531 31.1581 25.8528C31.1581 24.7518 30.2656 23.8594 29.1648 23.8594Z",
    fill: "#0F1CB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_2394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCarIcon);
export default __webpack_public_path__ + "static/media/HeaderCarIcon.be6e4bb541e6678880ee9e09baa95783.svg";
export { ForwardRef as ReactComponent };